import clsx from 'clsx';
import React from 'react';

type Props = {
  variant?: 'xs' | 'small' | 'medium' | 'large' | 'label' | 'title-lg';
  classes?: string;
  children: React.ReactNode;
};

const Paragraph = ({ variant = 'medium', classes = 'text-neutral-10', children }: Props) => {
  return (
    <>
      <p
        className={clsx(classes, {
          'body-sm': variant === 'xs',
          'text-sm font-normal leading-normal': variant === 'small',
          'body-lg': variant === 'medium',
          'text-lg font-light leading-8': variant === 'large',
          'label-lg': variant === 'label',
          'title-lg': variant === 'title-lg',
        })}
      >
        {children}
      </p>
    </>
  );
};

export default Paragraph;
